import api from "@/lib/axios";
import { unwrap, unwrapList } from "@/lib/strapi";
import { withFallback, mockList, mockOne } from "@/lib/fallback";
import { mockProducts } from "@/mocks/data";

export const productsApi = {
  list: (params = {}) =>
    withFallback(
      async () => unwrapList(await api.get("/products", { params })),
      () => mockList(mockProducts, params)
    ),
  get: (documentId, params = {}) =>
    withFallback(
      async () => unwrap(await api.get(`/products/${documentId}`, { params })),
      () => mockOne(mockProducts, documentId)
    ),
};
